function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 64.3,
  y: 87.4,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 87.3778 -33.0923)",
  width: 38.7,
  height: 3
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 69.2,
  y: 82.5,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 85.3492 -37.9899)",
  width: 38.7,
  height: 3
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 79.4,
  y: 8.1,
  transform: "matrix(0.7065 0.7078 -0.7078 0.7065 37.2872 -51.6302)",
  width: 3,
  height: 22.1
})));

var _ref4 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 58.8,
  y: 32.1,
  transform: "matrix(0.7065 0.7078 -0.7078 0.7065 45.8284 -30.9901)",
  width: 3,
  height: 15.4
})));

var _ref5 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M92.9,3c2.2,0,4,1.8,4,4s-1.8,4-4,4s-4-1.8-4-4S90.7,3,92.9,3 M92.9,0c-3.9,0-7,3.1-7,7s3.1,7,7,7c3.9,0,7-3.1,7-7 S96.8,0,92.9,0L92.9,0z"
}))));

var _ref6 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M50,43.9c3.3,0,6,2.7,6,6s-2.7,6-6,6c-3.3,0-6-2.7-6-6S46.7,43.9,50,43.9 M50,40.9c-5,0-9,4-9,9s4,9,9,9c5,0,9-4,9-9 S55,40.9,50,40.9L50,40.9z"
}))));

var _ref7 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M7,88.9c2.2,0,4,1.8,4,4s-1.8,4-4,4s-4-1.8-4-4S4.8,88.9,7,88.9 M7,85.9c-3.9,0-7,3.1-7,7s3.1,7,7,7c3.9,0,7-3.1,7-7 S10.9,85.9,7,85.9L7,85.9z"
}))));

var _ref8 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M50,18.7c17.2,0,31.3,14,31.3,31.3S67.2,81.3,50,81.3S18.7,67.2,18.7,50S32.8,18.7,50,18.7 M50,15.7 c-18.9,0-34.3,15.4-34.3,34.3S31.1,84.3,50,84.3S84.3,68.9,84.3,50S68.9,15.7,50,15.7L50,15.7z"
}))));

var _ref9 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M50,28.1c12.1,0,21.9,9.8,21.9,21.9S62.1,71.9,50,71.9S28.1,62.1,28.1,50S37.9,28.1,50,28.1 M50,25.1 c-13.8,0-24.9,11.2-24.9,24.9S36.2,74.9,50,74.9S74.9,63.8,74.9,50S63.8,25.1,50,25.1L50,25.1z"
}))));

var _ref10 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 17.4,
  y: 69.1,
  transform: "matrix(0.7065 0.7078 -0.7078 0.7065 62.9751 10.448)",
  width: 3,
  height: 24.1
})));

var _ref11 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 37.7,
  y: 52.5,
  transform: "matrix(0.7065 0.7078 -0.7078 0.7065 54.5479 -9.8953)",
  width: 3,
  height: 16.6
})));

var SvgLoop = function SvgLoop(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve"
  }, props), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("line", {
    style: {
      fill: "#EDEDED"
    },
    x1: 69.9,
    y1: 75.2,
    x2: 97.3,
    y2: 102.6
  }))), _ref), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("line", {
    style: {
      fill: "#EDEDED"
    },
    x1: 74.8,
    y1: 70.3,
    x2: 102.2,
    y2: 97.7
  }))), _ref2)), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("line", {
    style: {
      fill: "#EDEDED"
    },
    x1: 73.1,
    y1: 26.9,
    x2: 88.7,
    y2: 11.3
  }))), _ref3), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("line", {
    style: {
      fill: "#EDEDED"
    },
    x1: 54.8,
    y1: 45.2,
    x2: 65.7,
    y2: 34.3
  }))), _ref4), _ref5, _ref6, _ref7, _ref8, _ref9, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("line", {
    style: {
      fill: "#EDEDED"
    },
    x1: 10.4,
    y1: 89.7,
    x2: 27.4,
    y2: 72.6
  }))), _ref10), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("line", {
    style: {
      fill: "#EDEDED"
    },
    x1: 33.3,
    y1: 66.7,
    x2: 45.1,
    y2: 54.9
  }))), _ref11)));
};

export default __webpack_public_path__ + "static/media/loop.d55cb5f6.svg";
export { SvgLoop as ReactComponent };